import { render, staticRenderFns } from "./productFrameIntroduction.vue?vue&type=template&id=40e7f852&scoped=true&"
import script from "./productFrameIntroduction.vue?vue&type=script&lang=js&"
export * from "./productFrameIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./productFrameIntroduction.vue?vue&type=style&index=0&id=40e7f852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e7f852",
  null
  
)

export default component.exports